export default __webpack_public_path__ + "static/img_spindlebooks_solutions@2x-5c6ca85b9cd672ec56a3b8c2bf2a8f00.png";